import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { selectedQuoteSelector } from '../../../../../redux/quoteSlice';
import OrganizeFleetHOC from '../../../../../shared/OrganizeFleetHOC';
import { quoteStatuses } from '../../../const';

interface OrganizeFleetQuoteProps {
  value?: string
};

const OrganizeFleetQuote: FunctionComponent<OrganizeFleetQuoteProps> = () => {

  const parentComponentName = 'quote';

  const selectedQuote = useSelector(selectedQuoteSelector);

  const { id } = useParams<{ id: string }>();


  return (
    <>
      <OrganizeFleetHOC
        customerId={id}
        parentComponentName={parentComponentName}
        disableEditing={selectedQuote?.status === quoteStatuses.AUTHORIZED}
      />
    </>
  );
};

export default OrganizeFleetQuote;